__turbopack_context__.v({
  "clickable": "styles-module-scss-module__wy5ADW__clickable",
  "container": "styles-module-scss-module__wy5ADW__container",
  "dropShadow": "styles-module-scss-module__wy5ADW__dropShadow",
  "textContainer": "styles-module-scss-module__wy5ADW__textContainer",
  "videoContainer": "styles-module-scss-module__wy5ADW__videoContainer",
  "videoFirst": "styles-module-scss-module__wy5ADW__videoFirst",
});
